import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Signer ci-dessous", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"white","border":"1px solid gray","height":"300px","margin":"20px auto"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"auto","margin-right":"auto","width":"100%"} }, [
  /*#__PURE__*/_createElementVNode("video", {
    controls: "",
    src: "assets/video/IMG_3416.MOV",
    style: {"width":"100%"}
  })
], -1)

import {
  IonContent, IonHeader, IonPage, IonButtons,
  IonTitle, IonBackButton, IonButton,
  IonModal, IonCheckbox, 
  IonToolbar, onIonViewDidEnter
} from '@ionic/vue';
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import { getApi } from '@/helpers/api';
import { PeriodCountersApi, DtoCounter } from 'ppf-api-client';



export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentPage',
  setup(__props) {

const counters = ref<DtoCounter[]>([]);
const loading = ref(true);

const service = getApi(PeriodCountersApi);
const auth = useAuthStore();
const isModalOpen = ref(false);

//load inital data when entering the tab
onIonViewDidEnter(() => {
  loading.value = true;
  counters.value = [];

  service.periodCountersByPersonnel(auth.userId, new Date()).then(r => {
    counters.value = r.sort((a, b) => a.index - b.index);
    loading.value = false;
  });
});

function closeModal() {
  isModalOpen.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    defaultHref: "/",
                    text: _ctx.$t('g.back')
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalOpen.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Signer")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Utilisation de la machine à café")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonModal), {
            ref: "modal",
            "is-open": isModalOpen.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonToolbar), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Signature")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonContent), { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(IonCheckbox), { "label-placement": "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Je confirme avoir pris connaissance du document")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_1,
                  _hoisted_2,
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    strong: true,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Valider")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    strong: true,
                    fill: "outline",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Annuler")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})